import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Service } from '../../types/content';
import { focusRing } from '../../utils/styles';
interface ServiceCardProps {
  service: Service;
}
export function ServiceCard({
  service
}: ServiceCardProps) {
  const {
    t
  } = useLanguage();
  const Icon = service.icon;
  return <Link to={`/services#${service.id}`} className={`group flex h-full flex-col rounded-2xl border border-mist bg-white p-7 transition-[border-color,box-shadow] duration-200 ease-out hover:border-brand-light hover:shadow-[0_8px_30px_rgba(46,92,138,0.10)] ${focusRing}`} data-id="element-432" data-mp="1q3l8vcoo8xfa">
      <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-brand-tint text-brand" aria-hidden="true" data-id="element-433" data-mp="1laifp5nt3pzm">
        <Icon className="h-7 w-7" data-id="element-434" data-mp="28zti0rkt1sfv" />
      </span>
      <h3 className="mt-6 text-xl font-bold text-ink" data-id="element-435" data-mp="2dscvlojhsnko">{t(service.name)}</h3>
      <p className="mt-3 flex-1 leading-relaxed text-ink-soft" data-id="element-436" data-mp="2dtnw9fhn5f7k">{t(service.summary)}</p>
      <span className="mt-6 inline-flex items-center gap-2 font-semibold text-brand" data-id="element-437" data-mp="f78us8853ql">
        {t({
        en: 'Learn More',
        es: 'Ver Más'
      })}
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-438" data-mp="9a52y2n3ymji" />
      </span>
    </Link>;
}